<template>
  <div class="shift">
    <el-button icon="el-icon-refresh" @click="$refresh(getShiftsData)" class="refresh-btn">刷新</el-button>
    <div class="wrap">
      <!-- 条件查询 -->
      <div class="search">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="排班名称">
            <el-input v-model="searchForm.timeName" placeholder="请输入排班名称" />
          </el-form-item>
          <el-form-item label="排班类型">
            <el-select v-model="searchForm.type" placeholder="请选择班次类型">
              <el-option v-for="item in schedulingTypeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getShiftsData, true)">查询</el-button>
            <el-button icon="el-icon-refresh"
              @click="$reset(getShiftsData, { timeName: null, type: null })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作按钮 -->
      <div class="button" v-if="deptId">
        <el-button icon="el-icon-plus" type="primary" @click="addShift">新增班次</el-button>
      </div>
      <!-- 班次列表 -->
      <el-table v-loading="loading" :data="shiftList" :max-height="tableHeight" border>
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column prop="timeName" label="班次名称" />
        <el-table-column prop="timeRange" label="时间段" />
        <el-table-column prop="type" label="班次类型" :formatter="formatterType" />
        <el-table-column prop="deptName" label="班次医馆" v-if="!deptId" />
        <el-table-column prop="createBy" label="操作员" />
        <el-table-column prop="createTime" label="创建时间" min-width="150" />
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button icon="el-icon-delete" type="primary" @click="editShift(scope.row)">编辑</el-button>
            <el-button icon="el-icon-delete" type="danger" @click="deleteShift(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 新增弹框 -->
      <el-dialog class="dialogEdit" :title="dialogTitle" :visible.sync="dialogVisible" width="380px" @close="handleClose" :close-on-click-modal="false">
        <el-form :model="editForm" ref="editForm" :rules="editFormRules" label-width="100px" inline>
          <el-form-item label="班次名称" prop="timeName">
            <el-input v-model="editForm.timeName" placeholder="请输入班次名称" />
          </el-form-item>
          <el-form-item label="班次类型" prop="type">
            <el-select v-model="editForm.type" placeholder="请选择班次类型">
              <el-option v-for="item in schedulingTypeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间" prop="startTime">
            <el-time-select v-model="editForm.startTime" clearable
              :picker-options="{ start: '08:00', step: '00:30', end: '21:30' }" placeholder="开始时间" />
          </el-form-item>
          <el-form-item label="结束时间" prop="stopTime">
            <el-time-select v-model="editForm.stopTime" :picker-options="{ start: '08:00', step: '00:30', end: '24:00' }"
              placeholder="结束时间" />
          </el-form-item>
          <el-form-item label="预约时间段" prop="timeRule">
            <el-select v-model="editForm.timeRule" placeholder="请选择预约时间段">
              <el-option v-for="item in timeRule" :key="item.value" :label="item.info" :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="当前医馆">
            <el-input v-model="deptName" disabled/>
          </el-form-item>
        </el-form>
        <!-- 操作按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button type="success" @click="addSave">保存</el-button>
          <el-button @click="handleClose">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 分页 -->
      <el-pagination @current-change="page => $handleCurrentChange(page, getShiftsData)" :total="total"
        :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" />
    </div>
  </div>
</template>

<script lang="js">
import { shiftList, shiftAdd, shiftDelete, shiftEdit } from "@/api/shift";
import { getTimeRule } from "@/api/schedule"; // 排班请求
import { isNull, deepClone, dictText } from "@/utils/validateBase";
import { schedulingTypeList } from '@/utils/const'
export default {
  name: "Shift",
  data() {
    return {
      loading: true, // 加载中
      searchForm: { doctorName: null, daterange: null }, // 查询表单
      shiftList: [], // 排班列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      dialogVisible: false, // 新增或编辑弹框状态
      editForm: {}, // 新增或编辑表单
      multipleSelection: [], // 被选中行
      deptName: null, // 当前医馆
      deptId: this.$session.get("deptId"), // 当前医馆id
      editFormRules: {
        timeName: [{ required: true, message: "班次名称不能为空！", trigger: "blur" }],
        type: [{ required: true, message: "班次类型不能为空！", trigger: "blur" }],
        startTime: [{ required: true, message: "班次开始时间不能为空！", trigger: "change" }],
        stopTime: [{ required: true, message: "班次结束时间不能为空！", trigger: "change" }],
        timeRule: [{ required: true, message: "预约时间段不能为空！", trigger: "change" }],
      }, // 验证规则
      tableHeight: 0, // 表格最大高度
      timeRule: [],
      dialogTitle: '',
      schedulingTypeList: schedulingTypeList,//班次类型
    }
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.getShiftsData(); // 获取班次列表
    this.$session.get("options").forEach(item => { // 遍历得到当前医馆名称
      if (item.value == this.deptId) this.deptName = item.label;
    });
  },
  methods: {
    /**
     * 处理班次类型
     */
    formatterType(row){
      return dictText(row.type, schedulingTypeList)
    },
    // 请求所有班次列表
    async getShiftsData() {
      let params = { pageNum: this.currentPage, pageSize: this.pageSize, ...this.searchForm };
      let { total, rows, code } = await shiftList(params);
      if (code == 200) {
        if (total > 0) {
          rows.forEach(item => {
            if (![0,-1].includes(item.deptId)) this.$session.get("options").forEach(items => {
              if (item.deptId == items.value) item.deptName = items.label;
            });
            else item.deptName = "医馆公用";
            item.startTime = this.$computeTime(item.startTime);
            item.stopTime = this.$computeTime(item.stopTime);
            item.timeRange = item.startTime + "-" + item.stopTime;
          });
        }
        this.total = total;
        this.shiftList = rows;
      }
      this.loading = false;
    },
    // 新增班次
    addShift() {
      this.dialogTitle = '新增班次'
      getTimeRule().then(res => {
        if (res.code == 200) {
          this.timeRule = res.data
          this.dialogVisible = true;
          this.editForm = { timeName: null, type: '1', startTime: null, stopTime: null };
        }
      })
    },
    // 保存新增
    addSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          if (isNull(this.editForm.timeId)) {
            shiftAdd(this.handle()).then(res => {
              let { code } = res;
              if (code == 200) this.$message.success("新增班次成功！");
              this.dialogVisible = false;
              this.$refresh(this.getShiftsData);
            })
          } else {
            shiftEdit(this.handle()).then(res => {
              let { code } = res;
              if (code == 200) this.$message.success("修改班次成功！");
              this.dialogVisible = false;
              this.$refresh(this.getShiftsData);
            })
          }

        } else return false;
      })
    },
    // 处理参数
    handle() {
      let params = JSON.parse(JSON.stringify(this.editForm));
      params.startTime = parseInt(params.startTime.substring(0, 2)) * 60 + parseInt(params.startTime.substring(3));
      params.stopTime = parseInt(params.stopTime.substring(0, 2)) * 60 + parseInt(params.stopTime.substring(3));
      if (params.type == 1) params.deptId = this.deptId;
      return params;
    },
    // 删除班次
    deleteShift(row) {
      this.$confirm('确认删除该班次？').then(_ => { this.del(row) }).catch(_ => { });
    },
    async del(row) {
      let { code } = await shiftDelete(row.timeId);
      if (code == 200) this.$message.success("删除班次成功！");
      this.$refresh(this.getShiftsData);
    },
    /**
     * 编辑班次
     */
    editShift(row) {
      let newRow = deepClone(row)
      console.log(newRow,2222);
      this.dialogTitle = '编辑班次'
      // newRow.type = newRow.type == '固定' ? 0 : 1
      getTimeRule().then(res => {
        if (res.code == 200) {
          this.timeRule = res.data
          this.dialogVisible = true;
          this.editForm = newRow
        }
      })
    },
    /**
     * 关闭弹框
     */
    handleClose() {
      this.dialogTitle = ''
      this.dialogVisible = false
      this.editForm = {}
    }
  }
};
</script>

<style lang="less" scoped>
  .shift {
    box-sizing: border-box;
    padding: 20px;
  }
</style>
